export default class CampaignApi {
  constructor(client, url) {
    this.url = url
    this.client = client
  }

  getCampaignByCompany(company_id) {
    const params = {
      ...{ 'filters[eq:company_id]': company_id, 'filters[eq:type]': 'welcome' },
    }
    return this.client.get(`api/admin/campaigns`, { params }).then((response) => response.data)
  }

  postCampaignByCompany(params) {
    return this.client.post(`api/admin/campaigns`, params).then((response) => response.data)
  }
  patchCampaignByCompany(campaignId, params) {
    return this.client.patch(`api/admin/campaigns/${campaignId}`, params).then((response) => response.data)
  }
}
